<template>
  <div class="referred">
    <v-card-text>
      <v-row class="report-date-picker">
        <div class="col-6">
          <label class="from">{{ $t('fromDate') }}</label>
          <date-picker v-model="start_date"></date-picker>
        </div>
        <div class="col-6">
          <label class="to">{{ $t('toDate') }}</label>
          <date-picker v-model="end_date"></date-picker>
        </div>
      </v-row>
      <div class="req-list">
        <div class="req-card" style="padding: 2px" v-for="item in list"
             :key="item.Id">
          <div>
            <div class="row ">
              <div class="col-8">
                <div
                  class="req-name"
                  v-text="item.DocNo"
                ></div>
              </div>
              <div class="col-4">
                <div
                  class="req-name"
                  v-text="item.KardexCashNo"
                ></div>
              </div>
              <table class="table-border" style="width:100%">
                <tr>
                  <td>مانده (بس)</td>
                  <td>مانده (بد)</td>
                  <td>بستانکار</td>
                  <td>بدهکار</td>
                </tr>
                <tr>
                  <td>
                    <div
                    class="req-name"
                    v-text="item.Amount"
                  ></div></td>
                  <td>
                    <div
                      class="req-name"
                      v-text="item.AmountNegetive"
                    ></div>
                  </td>
                  <td>
                    <div
                      class="req-name"
                      v-text="item.AccBalance"
                    ></div>
                  </td>
                  <td>
                    <div
                      class="req-name"
                      v-text="item.AccBalanceNegetive"
                    ></div>
                  </td>
                </tr>
              </table>

            </div>

          </div>

        </div>
      </div>


    </v-card-text>

  </div>

</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'

import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {bus} from '../../main'
import {longClickDirective} from 'vue-long-click'
import Vue from 'vue'
import mapboxgl from "mapbox-gl";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

const longClickInstance = longClickDirective({delay: 500, interval: 5000})
Vue.directive('longclick', longClickInstance)
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}
import moment from 'moment-jalaali'

export default {
  props: [
    'passing_data'
  ],

  data() {
    return {
      first_load:true,
      list: [],
      start_date: "",
      end_date: "",
    }
  },
  components: {
    InfiniteLoading,
    Treeselect,
    datePicker: VuePersianDatetimePicker,

  },
  watch: {
    "start_date": function () {
      this.list = []
      this.get_data(1);

    },
    "end_date": function () {
      this.list = []

      this.get_data(1);

    },
  },
  mounted() {
    this.start_date = moment().utc().format('jYYYY/jMM/jDD');
    this.end_date = moment().utc().format('jYYYY/jMM/jDD');
    this.list = []
    const self = this
    setTimeout(function (){
      self.first_load = false
      self.get_data(1);
    },300)

  },

  methods: {
    get_data(page) {
      console.log("this.first_load",this.first_load,page)
      if(this.first_load){
        return false
      }
      var self = this
      var user_id = JSON.parse(localStorage.getItem('profile')).UserId
      const send_data = {
        UserId: user_id,
        PageNo: page,
        txtCode: "",
        isOld: 0,
        fdate: this.start_date,
        sdate: this.end_date,
      }

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetPersonAccounts', send_data, {})
        .then(response => {
          if (response.data.items.length > 0) {
            self.list.push(...response.data.items)

            self.get_data(page + 1)
          }

        }).catch(e => {
        this.errors.push(e)
      })
    },

  }
}
</script>
<style>
.table-border{
  border-collapse: collapse;

}
.table-border td{
  border:1px solid grey;
  padding: 2px;
}
</style>
